import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { POST_AIRA_SPEAKER } from "../../../utils/api";

export const SpeakerCopyButton = ({ text, index }) => {
  const cleanedText = text?.replace(/\n+/g, " ").trim() || "";
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // 🧹 Cleanup audio on text change or unmount
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlaying(false);
        audioRef.current = null;
      }
    };
  }, [cleanedText]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(cleanedText)
      .then(() => {
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 2000);
      })
      .catch(() => console.warn(""));
  };

  const handleToggleAudio = async () => {
    // Stop any playing audio
    if (isPlaying && audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      return;
    }

    // Replay if audio exists
    if (audioUrl && audioRef.current) {
      audioRef.current.play();
      setIsPlaying(true);
      audioRef.current.onended = () => setIsPlaying(false);
      return;
    }

    // Fetch and play audio
    try {
      const token = localStorage.getItem("access_token");
      const resp = await axios.post(
        POST_AIRA_SPEAKER,
        { text: cleanedText },
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
          responseType: "blob",
        }
      );

      const blob = resp.data;
      const url = URL.createObjectURL(blob);
      setAudioUrl(url);

      // Stop previous audio if any
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      const audio = new Audio(url);
      audioRef.current = audio;
      audio.play();
      setIsPlaying(true);

      audio.onended = () => setIsPlaying(false);
    } catch (err) {
      // console.error("Audio fetch failed:", err);
    }
  };

  return (
    <>
      <li>
        <button
          className="btn btn-round btn-round--actions"
          onClick={handleToggleAudio}
          title={isPlaying ? "Stop" : "Play"}
        >
          <img
            src="./assets/images/inner-pages/icons/icon-speaker.svg"
            alt="speaker"
          />
        </button>
      </li>

      <li className="position-relative">
        <button
          className="btn btn-round btn-round--actions"
          onClick={handleCopy}
        >
          <img
            src="./assets/images/inner-pages/icons/icon-copy.svg"
            alt="Copy"
          />
        </button>
        {copiedIndex === index && (
          <span className="tooltip-copied">Copied!</span>
        )}
      </li>
    </>
  );
};
